import { getSessionId } from './session'
import * as authService from '../auth'
import { device } from '../../utils'
import { insertLoggerToken } from './local'
const { REACT_APP_LOGGER_URL } = process.env

/**
 * @param { object } payload - Contem informacoes sobre o evento disparado
 * @param { string } payload.evento - Nome do evento disparado (busca, acesso, visualizacao, inclusao, remocao, atualizacao)
 * @param { string } payload.contexto - Contexto do evento (conteudo, favoritos, anotacoes)
 * @param { string } payload.origem - Contexto do evento (busca, favoritos, anotacoes)
 * @param { string } payload.tipo - Tipo do conteudo (aula, capitulo...)
 * @param { string } payload.conteudo - Id do conteúdo (referência do mongo)
 * @param { string } payload.usuario - Id do usuario
 * @param { string } payload.sessao - Representa a sessão do usuario no aplicativo
 * @param { string } payload.pergunta - Id da pergunta
 * @param { string } payload.resposta - Respota do aluno
 * @param { string } payload.inicio - Data do inicio da (prova, simulado, quiz, prova personalizada)
 */

const makeRequest = (payload = {}) => {
  const loggerRequest = new XMLHttpRequest()
  if (!payload.origem && !payload.contexto && payload.evento === 'visualizacao') {
    const origin = 'url'
    payload.origem = origin
    payload.contexto = origin
  }
  const params = Object.entries(payload).reduce(
    (params, [key, value]) => (value || value === 0 ? { ...params, [key]: value } : params),
    {}
  )

  params.sessao = getSessionId()
  params.plataforma = device.getPlatform()
  const data = JSON.stringify(params)
  const token = authService.getAccessToken()

  loggerRequest.open('POST', `${REACT_APP_LOGGER_URL}/register`, true)
  loggerRequest.setRequestHeader('Content-Type', 'application/json')
  loggerRequest.setRequestHeader('Authorization', `${token}`)
  loggerRequest.setRequestHeader('cache-control', 'no-cache')

  loggerRequest.send(data)
}
/**
 * @param { object } payload - Contem informacoes sobre o evento disparado
 * @param { string } payload.evento - Nome do evento disparado (acerto, pulo, erro, visualização)
 * @param { string } payload.contexto - Contexto do evento (curso, provas_simulados)
 * @param { string } payload.conteudo - Id do conteúdo (referência do mongo)
 * @param { string } payload.tipo - Tipo do conteudo (quiz, prova...)
 */

export const onShowTestResult = ({ conteudo, pergunta, tipo, origem, contexto, inicio, evento, resposta, topico }) => {
  const payload = {
    conteudo,
    pergunta,
    tipo,
    origem,
    topico,
    contexto,
    inicio,
    evento,
    resposta
  }

  payload.sessao = getSessionId()
  payload.plataforma = device.getPlatform()

  insertLoggerToken(payload)
  makeRequest(payload)
}